import { connect } from 'react-redux'
import RfidSettingComponent from '../components/RfidSettingComponent.jsx';
import {
	forwardToAssignRfidReader,
	forwardToAssignReaderName,
	forwardToAssignReaderHostName,
	forwardToAssignReaderPort,
	forwardToAssignReaderSensitivity,
	forwardToCreateReader,
	forwardToDeleteReaderByName
} from '../actions';

const mapStateToProps = (state) => ({
	rfid: state.getIn(['checkCardReducer', 'rfid']),
	validation: state.getIn(['checkCardReducer', 'validation'])
})

const mapDispatchToProps = (dispatch) => ({
	assignReaderName: (name) => {
		dispatch(forwardToAssignReaderName(name));
	},
	assignReaderHostName: (hostname) => {
		dispatch(forwardToAssignReaderHostName(hostname));
	},
	assignReaderPort: (port) => {
		dispatch(forwardToAssignReaderPort(port));
	},
	assignReaderSensitivity: (sensitivity) => {
		dispatch(forwardToAssignReaderSensitivity(sensitivity));
	},
	createReader: (reader) => {
		dispatch(forwardToCreateReader(reader));
	},
	assignRfidReader: (speedway) => {
		dispatch(forwardToAssignRfidReader(speedway));
	},
	deleteReaderByName: (speedwayName) => {
		dispatch(forwardToDeleteReaderByName(speedwayName));
	}
})

const RfidSettingContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(RfidSettingComponent)

export default RfidSettingContainer;


// WEBPACK FOOTER //
// ./src/containers/RfidSettingContainer.jsx